// @react-functional
import React from 'react';
import styles from './render_highlighted_parts.module.scss';

export function renderHighlightedParts(
  item: { highlighted: boolean; value: string },
  index: number,
) {
  if (item.highlighted) {
    return (
      <b className={styles.highlight} key={index}>
        {item.value}
      </b>
    );
  }
  return item.value;
}
